import { useMutation } from '@tanstack/react-query'

import { postPaymentRequestsBankAccount } from '@src/api'
import { DefaultApiPostPaymentRequestsBankAccountRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostPaymentRequestsBankAccount = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiPostPaymentRequestsBankAccountRequest) =>
      postPaymentRequestsBankAccount(axiosInstance, params),
  })
}
